// src/components/CustomerSummary/components/AverageStudyLengthTable.jsx
// ============================================================================
// BLOCK CS.UI.ASL.0 — AverageStudyLengthTable (read-only + resizable)
// ----------------------------------------------------------------------------
// INPUT FORMAT (tab-delimited; 3 columns)
//   <StudyType>\t<Unit>\t<Value>
// ============================================================================

import React from 'react';

import ResizableTextTable from './ResizableTextTable.jsx';
import { TABLE_FORMATS } from './tableFormats.js';

export default function AverageStudyLengthTable({ text, columnWidths, onColumnWidthsChange }) {
  return (
    <ResizableTextTable
      text={text}
      columnWidths={columnWidths}
      onColumnWidthsChange={onColumnWidthsChange}
      format={TABLE_FORMATS.averageRxLength}
    />
  );
}
